/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseModeComponent
 * Reason: Full view of the bank account overview OBC (`uiMode = 'full'`, TM-1000002030). Inherits the one
 *         navigation item from {@link CrCustomerBankAccountOverviewBaseComponent} and renders the ONE shared
 *         overview component in its wide variant (`[compact]` bound to false: two-column base data, all six table
 *         columns). No business logic and no form HTML of its own.
 *
 * @ticket TM-1000002030
 */
import {Component, OnInit} from '@angular/core';
import {CrCustomerBankAccountOverviewBaseComponent} from '../base/cr-customer-bank-account-overview-base.component';

@Component({
    selector: 'cr-customer-bank-account-overview-full',
    templateUrl: './cr-customer-bank-account-overview-full.component.html',
    styleUrls: ['./cr-customer-bank-account-overview-full.component.scss'],
    standalone: false
})
export class CrCustomerBankAccountOverviewFullComponent extends CrCustomerBankAccountOverviewBaseComponent
    implements OnInit {

    override ngOnInit(): void {
        super.ngOnInit();
    }

}
